import { gql } from "urql";

// Queries

// Get paginated list of TTS projects
export const ttsProjectPageQuery = gql`
    query TtsProjectPageQuery($page: Int!, $filter: TtsProjectPageFilter!) {
        ttsProjectPage(page: $page, filter: $filter) {
            items {
                id
                name
                created
                processingStatus
            }
            maxPage
        }
    }
`;

export type * from "./__generated__/tts-project-page-query";

// Get single TTS project with blocks
export const ttsProjectQuery = gql`
    query TtsProjectQuery($id: Int!) {
        ttsProject(id: $id) {
            id
            name
            created
            updated
            processingStatus
            blocks {
                edges {
                    node {
                        id
                        position
                        text
                        voice
                        instructions
                        silenceAfter
                        audioStale
                        file {
                            id
                            src
                            fileName
                        }
                    }
                }
            }
            file {
                id
                src
                fileName
            }
        }
    }
`;

export type * from "./__generated__/tts-project-query";

// Mutations

// Create a new TTS project
export const ttsProjectCreateMutation = gql`
    mutation TtsProjectCreateMutation($data: TtsProjectCreateInput!) {
        ttsProjectCreate(data: $data) {
            id
            name
        }
    }
`;

export type * from "./__generated__/tts-project-create-mutation";

// Delete a TTS project
export const ttsProjectDeleteMutation = gql`
    mutation TtsProjectDeleteMutation($id: Int!) {
        ttsProjectDelete(id: $id) {
            id
        }
    }
`;

export type * from "./__generated__/tts-project-delete-mutation";

// Update TTS project name
export const ttsProjectUpdateNameMutation = gql`
    mutation TtsProjectUpdateNameMutation($id: Int!, $name: String!) {
        ttsProjectUpdateName(id: $id, name: $name) {
            id
            name
        }
    }
`;

export type * from "./__generated__/tts-project-update-name-mutation";

// Create a new TTS block
export const ttsBlockCreateMutation = gql`
    mutation TtsBlockCreateMutation($projectId: Int!, $data: TtsBlockCreateInput!) {
        ttsBlockCreate(projectId: $projectId, data: $data) {
            id
            position
            text
            voice
            instructions
            silenceAfter
            audioStale
        }
    }
`;

export type * from "./__generated__/tts-block-create-mutation";

// Update a TTS block
export const ttsBlockUpdateMutation = gql`
    mutation TtsBlockUpdateMutation($id: Int!, $text: String, $voice: String, $instructions: String, $silenceAfter: Float) {
        ttsBlockUpdate(id: $id, text: $text, voice: $voice, instructions: $instructions, silenceAfter: $silenceAfter) {
            id
            position
            text
            voice
            instructions
            silenceAfter
            audioStale
        }
    }
`;

export type * from "./__generated__/tts-block-update-mutation";

// Delete a TTS block
export const ttsBlockDeleteMutation = gql`
    mutation TtsBlockDeleteMutation($id: Int!) {
        ttsBlockDelete(id: $id) {
            id
        }
    }
`;

export type * from "./__generated__/tts-block-delete-mutation";

// Move a TTS block
export const ttsBlockMoveMutation = gql`
    mutation TtsBlockMoveMutation($id: Int!, $newPosition: Int!) {
        ttsBlockMove(id: $id, newPosition: $newPosition) {
            id
            position
        }
    }
`;

export type * from "./__generated__/tts-block-move-mutation";

// Generate audio for a single TTS block
export const ttsBlockGenerateMutation = gql`
    mutation TtsBlockGenerateMutation($id: Int!) {
        ttsBlockGenerate(id: $id) {
            id
            audioStale
        }
    }
`;

export type * from "./__generated__/tts-block-generate-mutation";

// Generate all audio for a project
export const ttsProjectGenerateAllMutation = gql`
    mutation TtsProjectGenerateAllMutation($id: Int!) {
        ttsProjectGenerateAll(id: $id) {
            id
            processingStatus
        }
    }
`;

export type * from "./__generated__/tts-project-generate-all-mutation";

// Download stitched audio
export const ttsProjectDownloadMutation = gql`
    mutation TtsProjectDownloadMutation($id: Int!) {
        ttsProjectDownload(id: $id)
    }
`;

export type * from "./__generated__/tts-project-download-mutation";
